const getFileFormat = (fileName) => {
  const arr = fileName.split('.');
  return arr[arr.length - 1].toLowerCase();
};

export default getFileFormat;
